/**
 * Detect fn
 */
export default () => 'Symbol' in self && self.Symbol.length === 0
